<!--
 * Copyright (c) 2023 by Allen_sun email: Allen_sun_js@hotmail.com, All Rights Reserved.
-->
<template>
  <div class="performance">
    <div
      style="font-size: 16px; text-align: center; color: #ddd"
      v-if="
        new Date().getTime() <= new Date($route.query.endGradeTime).getTime()
      "
    >
      该班级未毕业暂无数据
    </div>

    <el-tabs v-else v-model="activeName" type="card" @tab-click="getList">
      <el-tab-pane label="自然月报" name="1">
        <div class="performance__controll">
          <div>
            时间：
            <el-date-picker
              v-model="pickerRange"
              type="monthrange"
              unlink-panels
              range-separator="-"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              :shortcuts="shortcuts"
              size="mini"
              format="YYYY/MM"
              value-format="YYYY-MM"
              @change="pickerChange"
            />
            &nbsp;&nbsp;
          </div>
          <div>
            &nbsp;&nbsp;门店：<el-select
              size="mini"
              v-model="institutionId"
              clearable
            >
              <el-option
                v-for="(name, id) in institutions"
                :key="name"
                :label="institutions[id]"
                :value="id"
              ></el-option>
            </el-select>
            &nbsp;&nbsp;
          </div>
          <div>
            &nbsp;&nbsp;岗位：<el-select size="mini" v-model="jobId" clearable>
              <el-option
                v-for="name in jobs"
                :key="name"
                :label="jobs[name]"
                :value="jobs[name]"
              ></el-option> </el-select
            >&nbsp;&nbsp;
          </div>
          <div style="flex: 1">
            <el-input
              style="width: 200px; float: right"
              type="text"
              size="mini"
              placeholder="搜索人员"
              prefix-icon="el-icon-search"
              v-model="keyWordSearch"
              @change="headerSearch"
              clearable
            >
            </el-input>
          </div>
        </div>
        <div class="performance__body">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column
              prop="time"
              label="时间"
              fixed="left"
              width="106"
              style="text-align: center"
            ></el-table-column>
            <el-table-column
              :key="'stu_' + index"
              prop="argv"
              style="text-align: center"
              :label="
                h('div', { style: 'text-align:center' }, [
                  h('div', { style: 'font-size:20px;color:#333;' }, ['平均']),
                ])
              "
            >
              <el-table-column label="算号">
                <template v-slot="scope">{{
                  scope.row.argv.calculateNum
                }}</template>
              </el-table-column>
              <el-table-column label="7天人均">
                <template v-slot="scope">
                  {{ scope.row.argv.sevenDaysAvg }}
                </template>
              </el-table-column>
              <el-table-column label="算号人均">
                <template v-slot="scope">
                  {{ scope.row.argv.avgConsume }}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              v-for="(item, key) in filtedHeaders"
              :key="key"
              :prop="key"
              style="text-align: center"
              :label="
                h('div', { style: 'text-align:center' }, [
                  h('div', { style: 'font-size:20px;color:#333;' }, [
                    item.username,
                    item.userStatus == 0
                      ? h('span', { style: 'font-size:18px;color:#999999' }, [
                          '（离职）',
                        ])
                      : '',
                  ]),
                  h('div', { style: 'font-size:18px;color:#999999' }, [
                    [`${item.jobName}/${item.institutionName}`],
                  ]),
                ])
              "
            >
              <el-table-column :prop="key" label="算号" width="80">
                <template v-slot="scope">
                  {{ scope.row[key]?.calculateNum }}
                </template>
              </el-table-column>
              <el-table-column :prop="key" label="7天人均" width="80">
                <template v-slot="scope">
                  {{ scope.row[key]?.sevenDaysAvg }}
                </template>
              </el-table-column>
              <el-table-column :prop="key" label="算号人均" width="80">
                <template v-slot="scope">
                  {{ scope.row[key]?.avgConsume }}
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="周期月报" name="2">
        <div class="performance__controll">
          <div>
            周期：
            <el-select clearable size="mini" v-model="cycle" @change="getList">
              <el-option label="1-3周期" value="3"></el-option>
              <el-option label="1-6周期" value="6"></el-option>
              <el-option label="1-12周期" value="12"></el-option>
              <el-option label="全部" value="0"></el-option>
            </el-select>
            &nbsp;&nbsp;
          </div>
          <div>
            &nbsp;&nbsp;门店：<el-select
              size="mini"
              v-model="institutionId"
              clearable
            >
              <el-option
                v-for="(name, id) in institutions"
                :key="name"
                :label="institutions[id]"
                :value="id"
              ></el-option>
            </el-select>
            &nbsp;&nbsp;
          </div>
          <div>
            &nbsp;&nbsp;岗位：<el-select size="mini" v-model="jobId" clearable>
              <el-option
                v-for="name in jobs"
                :key="name"
                :label="jobs[name]"
                :value="jobs[name]"
              ></el-option> </el-select
            >&nbsp;&nbsp;
          </div>
          <div style="flex: 1">
            <el-input
              style="width: 200px; float: right"
              type="text"
              size="mini"
              placeholder="搜索人员"
              prefix-icon="el-icon-search"
              v-model="keyWordSearch"
              @change="headerSearch"
              clearable
            >
            </el-input>
          </div>
        </div>
        <div class="performance__body">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column
              prop="time"
              label="时间"
              fixed="left"
              width="106"
              style="text-align: center"
            ></el-table-column>
            <el-table-column
              :key="'stu_' + index"
              prop="argv"
              style="text-align: center"
              :label="
                h('div', { style: 'text-align:center' }, [
                  h('div', { style: 'font-size:20px;color:#333;' }, ['合计']),
                ])
              "
            >
              <el-table-column label="算号">
                <template v-slot="scope">{{
                  scope.row.argv.calculateNum
                }}</template>
              </el-table-column>
              <el-table-column label="7天人均">
                <template v-slot="scope">
                  {{ scope.row.argv.sevenDaysAvg }}
                </template>
              </el-table-column>
              <el-table-column label="算号人均">
                <template v-slot="scope">
                  {{ scope.row.argv.avgConsume }}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              v-for="(item, key) in filtedHeaders"
              :key="key"
              :prop="key"
              style="text-align: center"
              :label="
                h('div', { style: 'text-align:center' }, [
                  h('div', { style: 'font-size:20px;color:#333;' }, [
                    item.username,
                    item.userStatus == 0
                      ? h('span', { style: 'font-size:18px;color:#999999' }, [
                          '（离职）',
                        ])
                      : '',
                  ]),
                  h('div', { style: 'font-size:18px;color:#999999' }, [
                    [`${item.jobName}/${item.institutionName}`],
                  ]),
                ])
              "
            >
              <el-table-column :prop="key" label="算号" width="80">
                <template v-slot="scope">
                  {{ scope.row[key]?.calculateNum }}
                </template>
              </el-table-column>
              <el-table-column :prop="key" label="7天人均" width="80">
                <template v-slot="scope">
                  {{ scope.row[key]?.sevenDaysAvg }}
                </template>
              </el-table-column>
              <el-table-column :prop="key" label="算号人均" width="80">
                <template v-slot="scope">
                  {{ scope.row[key]?.avgConsume }}
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { h } from "vue";
import http from "@/utils/request";
import { TimestampToDate } from "@/utils/utils.js";

export default {
  data: () => ({
    cycle: "0",
    activeName: "1",
    tableLoading: false,
    keyWordSearch: "",
    institutions: {},
    jobs: {},
    headerMap: {},
    tableData: [],
    pickerRange: [],
    institutionId: null,
    jobId: null,
    shortcuts: [
      {
        text: "本月",
        value: [new Date(), new Date()],
      },
      {
        text: "今年",
        value: () => {
          const end = new Date();
          const start = new Date(new Date().getFullYear(), 0);
          return [start, end];
        },
      },
      {
        text: "最近6个月",
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setMonth(start.getMonth() - 6);
          return [start, end];
        },
      },
      {
        text: "最近一年",
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setMonth(start.getMonth() - 11);
          return [start, end];
        },
      },
    ],
  }),
  computed: {
    filtedHeaders() {
      this.tableLoading = true;
      let timer = setTimeout(() => {
        this.tableLoading = false;
        clearTimeout(timer);
      }, 200);
      return !this.jobId && !this.institutionId && !this.keyWordSearch
        ? this.headerMap
        : Object.keys(this.headerMap).reduce((ref, cur) => {
            let cross = true;
            if (this.jobId) {
              let f = this.headerMap[cur].jobName == this.jobId;
              if (f) {
                cross = true;
              } else {
                return ref;
              }
            }
            if (this.institutionId) {
              let f = this.headerMap[cur].institutionId == this.institutionId;
              if (f) {
                cross = true;
              } else {
                return ref;
              }
            }
            if (this.keyWordSearch) {
              let f =
                this.headerMap[cur].username.indexOf(this.keyWordSearch) >= 0;
              if (f) {
                cross = true;
              } else {
                return ref;
              }
            }
            if (cross) {
              ref[cur] = this.headerMap[cur];
            }
            return ref;
          }, {});
    },
  },
  methods: {
    pickerChange(monthrange) {
      const start = new Date(monthrange[0]);
      const startend = new Date(start.setMonth(start.getMonth() + 11));
      const startendString = `${startend.getFullYear()}-${String(
        startend.getMonth() + 1
      ).padStart(2, "0")}`;
      const end = monthrange[1];
      if (startendString.split("-").join("") < end.split("-").join("")) {
        this.$message.error("不能超过12个月");
        let timer = setTimeout(() => {
          this.pickerRange = [];
          clearTimeout(timer);
        }, 500);
        return;
      }
      this.getList();
    },
    disabledDate() {
      return false;
    },
    h,
    renderHeader({ column }) {
      console.log(column);
      return h("div", { style: "display:flex;flex-direction: column" }, [
        h("div", { class: "handle_header__title" }, [
          h("div", { class: "handle_header__main" }, ["主要文字"]),
          h("div", { class: "handle_header__sub" }, ["次要文字"]),
        ]),
        h("div", { style: "display:flex;" }, [
          h("div", { style: "flex:0 0 100px" }, ["算号"]),
          h("div", { style: "flex:0 0 100px" }, ["7天人均"]),
          h("div", { style: "flex:0 0 100px" }, ["算号人均"]),
        ]),
      ]);
    },
    getList() {
      this.tableLoading = true;
      http
        .post("/corporate/university/ranke/queryWork", {
          beginDate: this.pickerRange[0],
          endDate: this.pickerRange[1],
          gradeId: this.$route.query.id,
          seachType: this.activeName, //1按月查询 2按周期
          cycle: this.cycle,
        })
        .then((res) => {
          if (res.data.code == 0) {
            const headerMap = {};
            const institutions = {};
            const jobs = {};
            const tableData = res.data.data.map((item) => {
              item.data.forEach((inner, index) => {
                if (index == 0) {
                  item.argv = inner;
                } else {
                  item[
                    inner.userId ? `${inner.userId + inner.jobName}` : "未知"
                  ] = inner;
                  // console.log(inner);
                  if (!headerMap[`${inner.userId + inner.jobName}`]) {
                    institutions[inner.institutionId] = inner.institutionName;
                    jobs[inner.jobName] = inner.jobName;
                    headerMap[`${inner.userId + inner.jobName}`] = inner;
                  }
                }
              });
              return item;
            });
            tableData.sort(
              (p, n) => new Date(n.time).getTime() - new Date(p.time).getTime()
            );
            this.institutions = institutions;
            this.jobs = jobs;
            this.headerMap = headerMap;
            this.tableData = tableData;
          }
          console.log(this.tableData);
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    getStartAndEndForEndGradeTime(date, type) {
      const oneYearInMs = 1000 * 60 * 60 * 24 * 365;
      const now = new Date().getTime();
      const targetDate = new Date(date).getTime();
      const diff = now - targetDate;
      if (diff > oneYearInMs) {
        return TimestampToDate(now - oneYearInMs, "YY-MM");
      } else {
        return TimestampToDate(targetDate, "YY-MM");
      }
    },
  },
  mounted() {
    this.pickerRange = [
      this.getStartAndEndForEndGradeTime(this.$route.query.endGradeTime),
      TimestampToDate(new Date().getTime(), "YY-MM"),
    ];
    this.getList();
  },
};
</script>

<style scoped>
.handle_header {
  display: flex;
  flex-direction: column;
}
.handle_header__content {
  display: flex;
}
.handle_header__title {
}
.performance__controll {
  font-size: 14px;
  display: flex;
}
.performance__body {
  margin-top: 25px;
}
.performance {
}
</style>
